__turbopack_context__.v({
  "container": "zMXYQW_container",
});
